import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_ENDPOINTS } from '../config';
import './PanelSocio.css';

function CargaMasiva() {
  const navigate = useNavigate();
  const [archivo, setArchivo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState('');
  const [resultado, setResultado] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validar que sea un archivo Excel o CSV
      const extension = file.name.split('.').pop().toLowerCase();
      if (extension !== 'xlsx' && extension !== 'xls' && extension !== 'csv') {
        setError('Por favor, seleccione un archivo Excel (.xlsx, .xls) o CSV');
        setArchivo(null);
        return;
      }
      setArchivo(file);
      setError('');
      setMensaje('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!archivo) {
      setError('Por favor, seleccione un archivo');
      return;
    }

    setLoading(true);
    setError('');
    setMensaje('');

    try {
      const formData = new FormData();
      formData.append('archivo', archivo);

      const token = localStorage.getItem('token');
      const response = await fetch(`${API_ENDPOINTS.SOCIOS}/carga-masiva`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: formData
      });

      const data = await response.json();

      if (response.ok) {
        setResultado(data);
        setMensaje(`Carga masiva completada: ${data.sociosCreados} socios procesados exitosamente`);
        setArchivo(null);
        // Limpiar el input de archivo
        const fileInput = document.getElementById('archivo');
        if (fileInput) fileInput.value = '';
      } else {
        setError(data.message || 'Error al procesar el archivo');
      }
    } catch (err) {
      setError('Error de red al procesar el archivo');
    }
    setLoading(false);
  };

  const handleCancel = () => {
    navigate('/admin');
  };

  return (
    <div className="panel-socio-bg">
      <div className="panel-socio-card" style={{maxWidth: 800, width: '100%'}}>
        <h2 className="panel-socio-title" style={{marginBottom: '1.5rem'}}>📊 Carga Masiva de Socios</h2>

        <div style={{marginBottom: '1.5rem', textAlign: 'center'}}>
          <p style={{color: '#666', fontSize: '1rem', marginBottom: '1rem'}}>
            Suba un archivo Excel (.xlsx, .xls) o CSV con los datos de los socios para cargar múltiples registros de una vez.
          </p>
          <div style={{backgroundColor: '#f8f9fa', padding: '1rem', borderRadius: '8px', border: '1px solid #dee2e6'}}>
            <h4 style={{color: '#D32F2F', marginBottom: '0.5rem'}}>📋 Formato requerido:</h4>
            <p style={{fontSize: '0.9rem', color: '#666', margin: 0}}>
              El archivo debe contener las columnas: <strong>nombreCompleto</strong>, <strong>documento</strong>, tipoDocumento, 
              direccion, correo, telefono, fechaNacimiento, categoria, anioUltimaCuota, <strong>numeroSocio</strong>, <strong>fechaIngreso</strong>
            </p>
            <p style={{fontSize: '0.8rem', color: '#888', margin: '0.5rem 0 0 0'}}>
              <strong>Nota:</strong> Las columnas en negrita son obligatorias. numeroSocio y fechaIngreso son opcionales. 
              Si fechaIngreso está vacía, se dejará en blanco en la base de datos.
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="panel-socio-form">
          <div className="form-bottom-row">
            <label style={{fontWeight: 'bold', color: '#D32F2F'}}>
              📁 Seleccionar archivo
            </label>
            <input
              id="archivo"
              type="file"
              accept=".xlsx,.xls,.csv"
              onChange={handleFileChange}
              style={{
                width: '100%',
                padding: '0.75rem',
                border: '2px solid #D32F2F',
                borderRadius: '8px',
                fontSize: '1rem',
                backgroundColor: '#fff'
              }}
            />
          </div>

          {archivo && (
            <div style={{marginBottom: '1rem', padding: '0.5rem', backgroundColor: '#e8f5e8', borderRadius: '4px', border: '1px solid #4caf50'}}>
              <p style={{margin: 0, color: '#2e7d32', fontSize: '0.9rem'}}>
                ✅ Archivo seleccionado: <strong>{archivo.name}</strong> ({(archivo.size / 1024).toFixed(1)} KB)
              </p>
            </div>
          )}

          <div style={{display: 'flex', gap: '1rem', justifyContent: 'center', marginTop: '1.5rem'}}>
            <button 
              type="submit" 
              className="btn-panel-socio btn-accion"
              disabled={loading || !archivo}
              style={{
                background: loading ? '#ccc' : 'linear-gradient(90deg, #4CAF50 0%, #45a049 100%)',
                color: 'white',
                minWidth: '200px'
              }}
            >
              {loading ? '⏳ Procesando...' : '📤 Cargar Socios'}
            </button>
            <button 
              type="button" 
              className="btn-panel-socio btn-accion"
              onClick={handleCancel}
              style={{
                background: 'linear-gradient(90deg, #BDBDBD 0%, #757575 100%)',
                color: 'white',
                minWidth: '200px'
              }}
            >
              ❌ Cancelar
            </button>
          </div>

          {error && <div className="panel-socio-error">{error}</div>}
          {mensaje && <div className="panel-socio-mensaje">{mensaje}</div>}

          {resultado && (
            <div style={{marginTop: '1.5rem', padding: '1rem', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6'}}>
              <h4 style={{color: '#D32F2F', marginBottom: '0.5rem'}}>📊 Resultado de la carga:</h4>
              <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '1rem', marginBottom: '1rem'}}>
                <div style={{textAlign: 'center', padding: '0.5rem', backgroundColor: '#e8f5e8', borderRadius: '4px'}}>
                  <div style={{fontSize: '1.5rem', fontWeight: 'bold', color: '#4caf50'}}>{resultado.sociosCreados || 0}</div>
                  <div style={{fontSize: '0.9rem', color: '#666'}}>Socios creados</div>
                </div>
                <div style={{textAlign: 'center', padding: '0.5rem', backgroundColor: '#fff3e0', borderRadius: '4px'}}>
                  <div style={{fontSize: '1.5rem', fontWeight: 'bold', color: '#ff9800'}}>{resultado.sociosActualizados || 0}</div>
                  <div style={{fontSize: '0.9rem', color: '#666'}}>Socios actualizados</div>
                </div>
                <div style={{textAlign: 'center', padding: '0.5rem', backgroundColor: '#ffebee', borderRadius: '4px'}}>
                  <div style={{fontSize: '1.5rem', fontWeight: 'bold', color: '#f44336'}}>{resultado.errores || 0}</div>
                  <div style={{fontSize: '0.9rem', color: '#666'}}>Errores</div>
                </div>
              </div>
              
              {/* Mostrar errores detallados si los hay */}
              {resultado.errores > 0 && resultado.detalles && resultado.detalles.length > 0 && (
                <div style={{marginTop: '1rem'}}>
                  <h5 style={{color: '#f44336', marginBottom: '0.5rem', fontSize: '1rem'}}>❌ Errores encontrados:</h5>
                  <div style={{maxHeight: '200px', overflowY: 'auto', backgroundColor: '#fff', border: '1px solid #ffcdd2', borderRadius: '4px', padding: '0.5rem'}}>
                    {resultado.detalles.map((error, index) => (
                      <div key={index} style={{
                        padding: '0.25rem 0.5rem',
                        marginBottom: '0.25rem',
                        backgroundColor: '#ffebee',
                        borderLeft: '3px solid #f44336',
                        fontSize: '0.85rem',
                        color: '#d32f2f'
                      }}>
                        {error}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </form>
      </div>
    </div>
  );
}

export default CargaMasiva;
